import { API_TIMETABLE_URL } from '@/config/constants'
import i18n from '@/utils/i18n'

interface TableCheckResult {
  errors: {
    [key: string]: string[]
  }
  error_counts: {
    [key: string]: number
  }
  total_errors: number
}

interface SimplifiedErrorCounts {
  roomConflicts: number
  teacherDoubleBooking: number
  classDoubleBooking: number
}

export const checkTimetable = async (timetableData: any): Promise<SimplifiedErrorCounts> => {
  try {
    // Prepare the same data structure as analyze-schedule
    let analyzeBody

    // Try to get the inputData from the server if available
    try {
      const timetableResponse = await fetch(
        `${import.meta.env.VITE_API_URL || 'http://localhost:3001'}/timetable/etablissement`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        }
      )

      if (timetableResponse.ok) {
        const serverTimetableData = await timetableResponse.json()
        if (serverTimetableData.inputData) {
          analyzeBody = {
            data: serverTimetableData.inputData,
            result: serverTimetableData.data,
          }
        }
      }
    } catch (error) {
      // console.error('Error fetching timetable for inputData:', error)
    }

    // Fallback to using the current data if we couldn't get inputData
    if (!analyzeBody) {
      // Check if the timetableData has originalInputData (from generator)
      if (timetableData.originalInputData) {
        analyzeBody = {
          data: timetableData.originalInputData,
          result: timetableData,
        }
      } else if (timetableData.inputData) {
        // Use inputData if available
        analyzeBody = {
          data: timetableData.inputData,
          result: timetableData,
        }
      } else {
        // Use the current data as both input and result
        analyzeBody = {
          data: timetableData,
          result: timetableData,
        }
      }
    }

    // Ensure we have the required structure
    if (!analyzeBody.data || !analyzeBody.result) {
      throw new Error(i18n.t('timetable.logic.checkTable.error'))
    }

    // console.log('Sending data to analyse_hard endpoint:', {
    //   hasData: !!analyzeBody.data,
    //   hasResult: !!analyzeBody.result,
    //   dataKeys: analyzeBody.data ? Object.keys(analyzeBody.data) : [],
    //   resultKeys: analyzeBody.result ? Object.keys(analyzeBody.result) : []
    // })

    // Send request to the new endpoint using the same URL pattern as TimetableGenerator
    const apiUrl = `${import.meta.env.VITE_API_TIMETABLE_URL || API_TIMETABLE_URL}/analyse_hard`
 // console.logMaking request to:', apiUrl)
    
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer 1d03360f4bcd533a1481905ed6bb9ae77bd650b901ee9c28bcf4dbffcc568575`,
      },
      body: JSON.stringify(analyzeBody),
    })

 // console.logResponse status:', response.status, response.statusText)

    if (!response.ok) {
      // Try to get error details from response
      try {
        const errorData = await response.text()
        // console.error('Server error response:', errorData)
        throw new Error(`HTTP error! status: ${response.status} - ${errorData}`)
      } catch (parseError) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
    }

    const result: TableCheckResult = await response.json()
 // console.logReceived response from analyse_hard:', result)

    // Extract only the required error counts
    const simplifiedCounts: SimplifiedErrorCounts = {
      roomConflicts: result.error_counts['Room Conflicts'] || 0,
      teacherDoubleBooking: result.error_counts['Teacher Double Booking'] || 0,
      classDoubleBooking: result.error_counts['Class Double Booking'] || 0,
    }

    return simplifiedCounts
  } catch (error) {
    // console.error('Error checking timetable:', error)
    throw new Error(i18n.t('timetable.logic.checkTable.error'))
  }
} 